/* eslint-disable no-unused-vars */
import React, { useState, useRef } from "react";
import "./MembreCard.scss";
import { FaCog } from "react-icons/fa";
import Modal from "Components/Modal/Modal";
import { Checkbox } from "primereact/checkbox";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { fr } from "date-fns/locale";
import { formatDate } from "../../../../Services/functions";
import axios from "axios";
import { Toast } from "primereact/toast";
import { connect } from "react-redux";
import neutralUser from "assets/neutralUser.png";

/**
 * Permet d'afficher les cards des utilisateurs avec leurs rôles s'ils en ont
 */
const MembreCard = (props) => {
  const successUpdate = useRef(null);
  const [modal, setModal] = useState(false);
  const [validerOffre, setValiderOffre] = useState(
    props.roles.some((role) => role.roleName.includes("VALIDATEUR_OFFRE"))
  );
  const [contributeur, setContributeur] = useState(
    props.roles.some((role) => role.roleName.includes("REDACTEUR_ACTU"))
  );
  const [dateFin, setDateFin] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const DATE_OPTIONS = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  const validateurOffreCheckbox = useRef(null);
  const contributeurCheckbox = useRef(null);
  const formatedDate = (date) => {
    const days = date.slice(0, 2);
    const month = date.slice(3, 5);
    const year = date.slice(6, date.length);
    const newDate = new Date();
    newDate.setDate(days);
    newDate.setMonth(month - 1);
    newDate.setUTCFullYear(year);
    return newDate;
  };
  const createObjForApi = (role, checkboxRole) => {
    const roleObj = {
      role: "",
      startAt: "",
      endAt: "",
    };
    const newRoleObj = new Object(roleObj);
    const roleWrite =
      checkboxRole === "validateur"
        ? `${role}_VALIDATEUR_OFFRE`
        : `${role}_REDACTEUR_ACTU`;
    const idRole = props.rolesFromDb.find(
      (role) => role.roleName === roleWrite
    ).id;
    newRoleObj.role = `/api/roles/${idRole}`;
    newRoleObj.startAt = new Date(Date.now());
    newRoleObj.endAt = formatedDate(dateFin);
    return newRoleObj;
  };
  const handlePostRole = () => {
    const rolesToAdd = [];
    const rolesToRemove = [];
    if (validateurOffreCheckbox.current.props.checked) {
      rolesToAdd.push(createObjForApi(props.currentRole, "validateur"));
    } else {
      rolesToRemove.push(createObjForApi(props.currentRole, "validateur"));
    }
    if (contributeurCheckbox.current.props.checked) {
      rolesToAdd.push(createObjForApi(props.currentRole, "redacteur"));
    } else {
      rolesToRemove.push(createObjForApi(props.currentRole, "redacteur"));
    }
    if (dateFin !== "") {
      removeRole(rolesToRemove);
      const url = `${process.env.REACT_APP_BASE_URL_API}/users/${props.userId}/assign_role`;

      axios
        .post(url, rolesToAdd, {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        })
        .then((res) => {
          if (res.status == 200) {
            props.handleRecherche();
            showSuccess();
            setModal(false);
            setErrorMessage(false);
          }
        })
        .catch((error) =>
          props.auth.toast?.current?.show({
            severity: "error",
            summary: "Erreur",
            detail: error?.response?.data?.detail || "Une erreur est survenue",
            life: 5000,
          })
        );
    } else {
      setErrorMessage(true);
    }
  };

  const removeRole = (data) => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/users/${props.userId}/remove_role`;
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        props.handleRecherche();
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour des rôles a bien été prise en compte",
      life: 3000,
    });
  };

  const displayName = (role) => {
    if (role.includes("REDACTEUR_ACTU")) return "Rédacteur d'actu";
    if (role.includes("VALIDATEUR_OFFRE")) return "Validateur d'offre";
    return "";
  };
  return (
    <div className="membre_card">
      <Toast ref={successUpdate} />
      <div className="membre_card__title">
        <img src={props.imageUrl ? props.imageUrl : neutralUser} />
        <h6>
          {props.prenom} {props.nom}
        </h6>
      </div>
      <div className="membre_card__item__roles">
        {props.roles.map((role, index) => (
          <div key={index} className="membre_card__item__roles__infos">
            <p className="membre_card__item__roles__infos__roleName">
              {displayName(role.roleName)}
            </p>
            {role?.endAt && (
              <p className="membre_card__item__roles__infos__roleEndDate">
                Date de fin des droits attribués :{" "}
                <strong>{formatDate(role.endAt)}</strong>
              </p>
            )}
            {role?.userRoleInfos?.length > 0 && (
              <p className="membre_card__item__roles__infos__roleEndDate">
                Date de fin des droits attribués :{" "}
                <strong>{formatDate(role.userRoleInfos[0].endAt)}</strong>
              </p>
            )}
          </div>
        ))}
      </div>
      <div>
        <FaCog size={"1.5rem"} onClick={() => setModal(true)} />
      </div>
      {modal && (
        <Modal
          visible={modal}
          setVisible={setModal}
          header="Attribuer ou modifier des droits"
          height="fit-content"
        >
          <div className="membre_card__checkboxes">
            <div className="membre_card__checkbox">
              <Checkbox
                checked={validerOffre}
                onChange={(e) => setValiderOffre(e.checked)}
                name="VALIDATEUR_OFFRE"
                ref={validateurOffreCheckbox}
              />
              <label className="membre_card__checkbox__label">
                Valider les offres : permet à un utilisateur d’accéder à la page
                de validation des offres.
              </label>
            </div>
            <div className="membre_card__checkbox">
              <Checkbox
                checked={contributeur}
                onChange={(e) => setContributeur(e.checked)}
                name="REDACTEUR_ACTU"
                ref={contributeurCheckbox}
              />
              <label className="membre_card__checkbox__label">
                Rédiger des actus : permet à un utilisateur d’accéder à la
                rédaction des actus.
              </label>
            </div>
            <div className="membre_card__checkbox">
              <p>Choisir une date de fin d&apos;attribution des droits : </p>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={fr}>
                <DatePicker
                  label="Date de fin"
                  placeholderText="Date de fin"
                  selected={dateFin === " " ? null : dateFin}
                  onChange={(date) => {
                    setDateFin(
                      new Intl.DateTimeFormat("fr-FR", DATE_OPTIONS).format(
                        date,
                        "DD/MM/YY"
                      )
                    ),
                      setErrorMessage(false);
                  }}
                  labelFunc={() => dateFin || "08/05/2022..."}
                  cancelLabel="Annuler"
                />
              </MuiPickersUtilsProvider>
            </div>
            {errorMessage && (
              <p className="membre_card__checkboxes__errorDateMessage">
                Veuillez choisir une date
              </p>
            )}
          </div>
          <div className="membre_card__boutons">
            <BtnBleu btnTexte="Valider" btnAction={() => handlePostRole()} />
            <BtnBlanc btnTexte="Annuler" btnAction={() => setModal(false)} />
          </div>
        </Modal>
      )}
    </div>
  );
};

MembreCard.propTypes = {
  contributeur: PropTypes.bool,
  dejaRole: PropTypes.bool,
  id: PropTypes.number,
  nom: PropTypes.string,
  prenom: PropTypes.string,
  currentRole: PropTypes.string,
  roles: PropTypes.array,
  handleRecherche: PropTypes.func,
  auth: PropTypes.object,
  attribuerDroits: PropTypes.bool,
  userRoleInfos: PropTypes.array,
  rolesFromDb: PropTypes.array,
  userId: PropTypes.number,
  imageUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({ auth: state.auth });

export default connect(mapStateToProps)(MembreCard);
